<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <app-ag-grid  [gridOptions]="johGridOptions"> </app-ag-grid>
</ng-template>

<ng-template #footerTemplate>
  <button (click)="ok()"
  pButton type="button" class="p-button-raised">
  Ok
  </button>
</ng-template>
